import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "range",
      description: "数据范围（索引值），形如[${min}, ${max}]的数组",
      type: "Array",
      required: "是"
    },
    {
      prop: "value",
      description: "绑定值，为索引数值，可指定初值",
      type: "Number",
      required: "是"
    },
    {
      prop: "step",
      description: "range范围内每tick的步进值",
      type: "Array",
      required: "是"
    },
    {
      prop: "getLabel",
      description: "获取标签的回调函数",
      type: "Function"
    },
    {
      prop: "showLabel",
      description: "显示标签，否则只在拖动时显示",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "theme",
      description: "主题样式，可选default、fill",
      type: "String",
      default: "default"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
